const autocompleteFormParamEquipModel = {
  serviceTypes: 'Service Types',
  frequency: 'Frequency',
  groups: 'Group',
};

export default autocompleteFormParamEquipModel;
